var _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeTypeRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      fillOpacity: 1
    },
    d: "M39 16v25a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17l11 11z",
    fill: "#50e6ff"
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 -3890)",
    y2: -3900.4,
    y1: -3905.471,
    x2: 33.6,
    x1: 28.529,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3079d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297cd2",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccc",
      fillOpacity: 1
    },
    d: "M28 5v9a2 2 0 0 0 2 2h9L28 5z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.26 46.827 11.39-12.656-1.415-1.414-12.656 11.39a1.897 1.897 0 1 0 2.68 2.68z",
    fill: "#ad3f16",
    style: {
      fill: "#626262",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1) rotate(-45.001)",
    fill: "#751b0b",
    style: {
      fill: "#41403f",
      fillOpacity: 1
    },
    d: "M-52.994-7.632h12.036v7.57h-12.036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.126 36.021 5.355-5.355a.983.983 0 0 0 0-1.39l-4.309-4.309a.983.983 0 0 0-1.39 0l-5.355 5.355a.983.983 0 0 0 0 1.39l4.31 4.309a.983.983 0 0 0 1.39 0zm-7.101-7.125 5.331-5.331a.999.999 0 1 0-1.414-1.414l-5.33 5.331a1 1 0 0 0 1.414 1.414zm9.9 9.899 5.331-5.331a.999.999 0 1 0-1.414-1.414l-5.33 5.331a.999.999 0 1 0 1.414 1.414z",
    fill: "#d6742d",
    style: {
      fill: "#828181",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.37 46.104 20.074 24.808a.205.205 0 0 0-.29 0l-.867.869c-.08.08-.08.21 0 .29l21.295 21.295c.08.08.21.08.29 0l.868-.869c.08-.08.08-.21 0-.29z",
    fill: "#e52030",
    style: {
      strokeWidth: 0.537463
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeTypeRelease);
export default __webpack_public_path__ + "static/media/noticeTypeRelease.cb1a145f3381d66ce8fff7adcb3e90e8.svg";
export { ForwardRef as ReactComponent };